//region :: Imports ::
import {WorkerType} from '../Api/WorkerHubClients';
import {MNullable} from '../Toolkit/Utils';
import * as Yup from 'yup';

//endregion

/** */
export class Worker {

    public id: string = '';
    public key: string = '';
    public firstName: string = '';
    public lastName: string = '';
    public workerType: MNullable<WorkerType> = null;
    public existsInEnergy: boolean = false;
    public existsInNhs: boolean = false;
    public createdBy: string = '';
    public createdOn: MNullable<Date> = null;
    public modifiedBy: string = '';
    public modifiedOn: MNullable<Date> = null;
    public organizationUnitRef: string = '';
    public managerReference: string = '';

}

/** */
export class EntityReference {
    public id: string = '';
    public name: string ='';
    public logicalName: string = ''
    public keyAttributes: MNullable<[]> = [];
    public rowVersion: number | null = null;
}

/** */
export class WorkerValidator {

    public static readonly firstName = Yup.string().label('First Name').max(100).required();
    public static readonly lastName = Yup.string().label('Last Name').max(100).required();
    public static readonly workerType = Yup.number().label('Worker Type').nullable().required();
    public static readonly organizationUnit = Yup.string().label('Organisation Unit').required();
    public static readonly jobTitle = Yup.string().label('Job Title').required();
    public static readonly resourceManager = Yup.string().label('Resource Manager').optional();
    public static readonly startDate = Yup.date().label('Start Date').nullable().optional();
    public static readonly dateOfBirth = Yup.date().label('Date Of Birth').nullable().optional();
    public static readonly emailAddress = Yup.string().label('Email Address').email().max(100).optional();
    public static readonly workPhoneNumber = Yup.string().label('Work Phone Number').max(29).optional();
    public static readonly personalPhoneNumber = Yup.string().label('Personal Phone Number').max(29).optional();
    public static readonly contractingAgency = Yup.string().label('Contracting Agency').required();
    public static readonly thirdPartySupplier = Yup.string().label('3rd Party Supplier').required();

    public static readonly address = Yup.string().label('Address').max(2000)
                                        .when('workerType', {
                                            is: WorkerType.Contractor || WorkerType.Subcontractor,
                                            then: (schema) => schema.required(),
                                            otherwise: (schema) => schema.optional()
                                        });

    public static readonly postCode = Yup.string().label('Post Code').max(15)
                                         .when('workerType', {
                                             is: WorkerType.Contractor || WorkerType.Subcontractor,
                                             then: (schema) => schema.required(),
                                             otherwise: (schema) => schema.optional()
                                         });

    
}

/** */
export class WorkerReply {
    public worker: MNullable<Worker> = null;
}

/** */
export class WorkerListReply {
    public workers: Worker[] = [];
}

/** */
export class CreateWorkerReply {
    public worker: MNullable<Worker> = null;
}

/** */
export class UpdateWorkerReply {
    public worker: MNullable<Worker> = null;
}

/** */
export class WorkerLookupReply {
    public lookup: MNullable<EntityReference> = null;
}
